export default __webpack_public_path__ + "static/media/popular-javascript-library-in-2020.5c7e8b1b.md";